module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_vorderthal-df6de914f69a8d144a0c52393bee39bf.png";